<template>
  <transition name="fade">
    <div
      class="calc-card"
      :class="{ 'calc-card--opened': isOpened }"
    >
      <div
        class="calc-card__header"
        @click="openCalc($event)"
      >
        <h4>{{ calcData.name }}</h4>
        <div class="calc-card__info">
          <transition name="fade">
            <div
              v-show="isOpened && calcData.refText"
              class="reference-tooltip"
              @click="openRef()"
            >
              <md-tooltip
                class="tooltip-ref"
                md-direction="top"
              >
                Ver referência
              </md-tooltip>
              <svg-loader src="/static/images/icon-info.svg" />
            </div>
          </transition>
          <svg-loader
            class="arrow"
            src="/static/images/arrow-up.svg"
          />
        </div>
      </div>
      <transition name="fade">
        <div
          v-show="ref"
          class="calc-card__reference"
        >
          Referência: {{ calcData.refText }}

          <button
            class="btn--transparent-with-icon"
            @click="closeRef()"
          >
            <svg-loader src="/static/images/icon-close-purple.svg" />
          </button>
        </div>
      </transition>

      <!-- Slot To recieve Form to Calc -->
      <transition name="slide">
        <div
          v-show="isOpened"
          class="calc-card__form"
        >
          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'CalculationCard',
  props: {
    calcData: {
      required: true,
      type: Object
    }
  },
  data: () => {
    return {
      isOpened: false,
      ref: false
    }
  },
  methods: {
    openCalc(e) {
      const clickedElementClassName = e.target.parentElement.parentElement.className
      if (clickedElementClassName !== 'reference-tooltip') {
        this.isOpened = !this.isOpened
        this.ref = false
      }
    },
    openRef(e) {
      this.ref = true
    },
    closeRef() {
      this.ref = false
    }
  }
}
</script>
<style lang="scss">
.calc-card {
  background: #ffffff;
  padding: 24px;
  border-radius: 3px;
  margin-top: 16px;

  .arrow {
    transform: rotate(180deg);
    transition: all ease-in-out 0.3s;
  }

  .alert-error {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 5px;
    }
    span {
      font-weight: 500;
    }
  }

  &--opened {
    .arrow {
      transform: rotate(0);
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-content: center;
    cursor: pointer;

    h4 {
      color: #464646;
      font-size: 13px;
      flex-shrink: 1;
    }

    .md-icon {
      fill: #464646;
      min-width: 20px;
      margin-left: 8px;
    }
  }

  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .reference-tooltip {
      .md-icon svg {
        fill: #464646;
      }
    }
  }

  &__reference {
    padding: 15px;
    color: #4a4a4a;
    font-size: 11px;
    font-weight: 600;
    line-height: 13.2px;
    border-radius: 6px;
    background: rgba(245, 166, 35, 0.2);
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .btn--transparent-with-icon {
      margin-left: 10px;
    }

    .md-icon {
      min-width: 11px;
      width: 11px;
      height: 11px;
      min-height: 11px;
    }
  }

  &__form {
    margin-top: 24px;

    p {
      color: #818181;
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
    }
  }

  .btn-calc {
    width: 102px;
    height: 32px;
    background: #7f1a54;
    border-radius: 4px;
    font-family: 'Exo 2' !important;
    font-weight: 600;
    font-size: 11.11px;
    line-height: 13px;
    text-transform: uppercase;
    margin: 8px auto 0;
  }

  &__result {
    margin-top: 24px;
    text-align: center;

    p {
      font-weight: 400;
      margin: 8px 0;

      strong {
        color: #818181;
      }
      span {
        font-weight: 700;
        color: #7f1a54;
      }
    }
  }
}
.tooltip-ref {
  z-index: 1000;
}

.slide-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
